import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '@/store/index'
import Tool from '@/assets/js/utils'
Vue.use(VueRouter)

const Schedule = () => import('@/components/scheduleModule/index')
const MediaHub = () => import(/* webpackChunkName: "media-hub" */ '@/components/mediaHub/index')
const OperateCenter = () => import(/* webpackChunkName: "operate-center" */ '@/components/operateCenter/index')
const Destinations = () => import(/* webpackChunkName: "destinations" */ '@/components/destinations/index')
const ColorCorrection = () => import(/* webpackChunkName: "color-correction" */ '@/components/colorCorrection/index')
const SourcePop = () => import(/* webpackChunkName: "source-pop" */ '@/components/SourceObject/index.vue')
const ProfilePop = () => import(/* webpackChunkName: "profile-pop" */ '@/components/destinations/profilePop.vue')
const artView = () => import(/* webpackChunkName: "art-view" */ '@/components/htmlArt/index.vue')
const ApiLog = () => import(/* webpackChunkName: "api-log" */ '@/components/apiLog/index.vue') // 隐藏的 API 日志页 [Claude Code]

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'mediaHub',
    component: MediaHub
  },
  // {
  //   path: '/log',
  //   name: 'logPage',
  //   component: LogPage
  // },
  {
    path: '/colorCorrection',
    name: 'colorCorrection',
    component: ColorCorrection
  },
  {
    path: '/operateCenter',
    name: 'operateCenter',
    component: OperateCenter
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: Schedule
  },
  {
    path: '/destinations',
    name: 'destinations',
    component: Destinations
  },
  {
    path: '/sourcePop',
    name: 'sourcePop',
    component: SourcePop
  },
  {
    path: '/profilePop',
    name: 'profilePop',
    component: ProfilePop
  },
  {
    path: '/art',
    name: 'art',
    component: artView
  },
  {
    // 隐藏的 API 日志页，不在导航中展示 [Claude Code]
    path: '/apiLog',
    name: 'apiLog',
    component: ApiLog
  },
  {
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({
  base: process.env.NODE_ENV === 'production' ? '/' : '/mediahub/',
  routes
})

router.beforeEach(async (to, from, next) => {
  await Store.dispatch('getInitConfigFn')
  next()
})
router.afterEach((to, from) => {
  if (to.name) {
    Tool.controlLoading(false)
  }
})

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch((err) => err)
}

export default router
